import { render, staticRenderFns } from "./ClientsCertificatesEdit.vue?vue&type=template&id=7892c5e4&"
import script from "./ClientsCertificatesEdit.vue?vue&type=script&lang=js&"
export * from "./ClientsCertificatesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports